import { render, staticRenderFns } from "./companyprofile.vue?vue&type=template&id=1aaa701c"
import script from "./companyprofile.vue?vue&type=script&lang=js"
export * from "./companyprofile.vue?vue&type=script&lang=js"
import style0 from "./companyprofile.vue?vue&type=style&index=0&id=1aaa701c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports